import DTO from './DTO';

class SystemEventsFormDTO extends DTO {
  constructor(params, isValidInit) {
    const attributes = [
      {
        name: 'find',
        type: String,
        labelKey: 'search',
      },
      {
        name: 'date',
        type: String,
        labelKey: 'date',
      },
      {
        name: 'module',
        type: String,
        labelKey: 'module',
      },
      {
        name: 'level',
        type: String,
        labelKey: 'level',
      },
    ];
    super(attributes, params, isValidInit);
  }

  getData() {
    return {};
  }
}

export default SystemEventsFormDTO;
